<template>
  <b-row align-content="start" border-variant="primary" class="py-1 mb-2 border-bottom border-light text-left">
    <b-col cols="4" class="text-dark font-weight-bold">{{ title }}</b-col>
    <b-col cols="6">
      <div class="text-dark" v-if="changeType==='phoneNumber'">
        <b-row>
          <b-col class="ml-1 pl-0">{{data}}</b-col>
        </b-row>
      </div>
      <b-form-input 
        v-else-if="isEditing && canChangeDefaultItem"
        v-model="localEditedValue"
        @input="onInputChange"
        @blur="onBlur"
        @keyup.enter="onEnter"
        @keyup.esc="onEscape"
        size="sm"
        class="text-dark"
      ></b-form-input>
      <div v-else class="text-dark">{{data}}</div>
    </b-col>
    <b-col cols="2">
      <template v-if="canChangeDefaultItem">
        <b-button 
          v-if="!isEditing"
          variant="outline-primary" 
          size="sm" 
          @click="startEditing" 
          v-b-tooltip.hover.topright 
          :title="editLabelOrDefault">
          <b-icon icon="pencil-fill"></b-icon>
        </b-button>
        <b-button 
          v-else
          variant="outline-secondary" 
          size="sm" 
          @click="cancelEditing" 
          v-b-tooltip.hover.topright 
          title="Cancel">
          <b-icon icon="x"></b-icon>
        </b-button>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import store from "@/store/store";

export default {
  name: "DeviceDetailRowItem",
  props: {
    title: {type: String},
    data: {type: String},
    editLabel: {type: String},
    changeType: {type: String},
    isEditing: {type: Boolean, default: false},
    editedValue: {type: String, default: ''}
  },
  data() {
    return {
      localEditedValue: ''
    }
  },
  watch: {
    editedValue(newVal) {
      this.localEditedValue = newVal
    },
    isEditing(newVal) {
      if (newVal) {
        this.localEditedValue = this.data
      }
    }
  },
  computed: {
    editLabelOrDefault() {
      return this.editLabel ? this.editLabel : this.$t('unitChanges.rowToolTip')
    },
    canChangeDefaultItem() {
      if(this.changeType === 'hostname') {
        return store.getters.isUpdateClientAliasAllowed
      }
      if(this.changeType === 'alias') {
        return store.getters.isUpdateClientAliasAllowed
      }
      return false
    }
  },
  methods: {
    changeUnitDetail() {
      this.$emit('changeDeviceItem', this.changeType)
    },
    startEditing() {
      this.localEditedValue = this.data
      this.$emit('startEditing', this.changeType)
    },
    cancelEditing() {
      this.localEditedValue = this.data
      this.$emit('cancelEditing', this.changeType)
    },
    onInputChange() {
      this.$emit('valueChanged', this.changeType, this.localEditedValue)
    },
    onBlur() {
      // Keep editing mode, don't auto-cancel on blur
    },
    onEnter() {
      this.$emit('saveEditing', this.changeType, this.localEditedValue)
    },
    onEscape() {
      this.cancelEditing()
    }
  }
}
</script>

<style scoped>

</style>